export class TempoExperiencia {
  descricao: string;
  valorNumerico: number;
}
